// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type MaterialtransportPage } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SucheMaterialtransporteAnfuhrQuery = {
  search?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useSucheMaterialtransporteAnfuhr(): (
  taetigkeitsberichtId: string,
  fuhrparkeintragId: string,
  query: SucheMaterialtransporteAnfuhrQuery
) => Promise<MaterialtransportPage> {
  const getAPI = useGetApi();
  return useCallback(
    async (taetigkeitsberichtId, fuhrparkeintragId, query = {}) =>
      (await getAPI()).materialtransporte.sucheMaterialtransporteAnfuhr({
        taetigkeitsberichtId,
        fuhrparkeintragId,
        ...query,
      }),
    [getAPI]
  );
}
